import styled from 'styled-components';

export const MEDIA = {
    tablet: 'max-width: 1279px',
    mobile: 'max-width: 639px',
};

export const FooterLinks = styled.div`
    display: block;
`;

export const LinksTitle = styled.p`
    margin: 0;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
`;

export const LinksList = styled.ul`
    margin: 0;
    padding-left: 0;
    font-size: 14px;
    line-height: 18px;
    color: #979797;
`;

export const ListItem = styled.li`
    list-style: none;
    line-height: 25px;
`;

export const ListItemA = styled.a`
    font-size: 14px;
    color: #979797;
    transition: 0.25s;
    &:hover {
        color: #000;
        transition: 0.25s;
    }
`;
